import { useOutletContext } from "react-router-dom"
import dayjs from "dayjs"

const LABEL_SENT = "Sent"
const LABEL_EMAIL = "Email"
const LABEL_OPENED = "Opened"
const LABEL_CLICKED = "Clicked"
const LABEL_INVESTOR = "Investor"
const LABEL_DELIVERED = "Delivered"


const formatDate = (isoDateTime) =>
  isoDateTime ? dayjs(isoDateTime).format('MM/DD/YYYY HH:mm:ss') : 'Never'


const useExportColumns = () => {
  const { computeAccountFullname } = useOutletContext()

  const columns = [
    {
      value: ({ investorAccountId }) => computeAccountFullname(investorAccountId),
      title: LABEL_INVESTOR,
    },
    {
      value: ({ recipientEmail }) => recipientEmail,
      title: LABEL_EMAIL,
    },
    {
      value: ({ sentAt }) => formatDate(sentAt),
      title: LABEL_SENT,
    },
    {
      value: ({ deliveredAt }) => formatDate(deliveredAt),
      title: LABEL_DELIVERED,
    },
    {
      value: ({ openedAt }) => formatDate(openedAt),
      title: LABEL_OPENED,
    },
    {
      value: ({ clickedAt }) => formatDate(clickedAt),
      title: LABEL_CLICKED,
    },
  ]

  return columns
}

export default useExportColumns
